import axios from "axios";
import {Message, MessageBox, Notification} from "element-ui";
import store from '@/store'
import {getToken} from "@/utils/auth";
import router from "../router";
let isRefreshing = false;
let listRequests = [];  //把阻塞的请求储存到数组里一次请求玩

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000, // 请求超时时间
  withCredentials: true
});

// request拦截器
service.interceptors.request.use(
  config => {
    // console.log("request config:" +  JSON.stringify(config));

    // 当存在token   并且是post方法
    if (store.getters.token && config["method"] == 'post') {
      if (config.data instanceof FormData) {  // 判断是否是FormData格式
        // // 当无感刷新token后，再次发请求要更新FormData表单里的token（第一次请求还是多次请求都会走进来，不影响）
        config.data.set('token', store.getters.token); // 使用set方法替换
        // for (let [a, b] of config.data.entries()) {
        //         //   console.log(a, b)
        //         // }
      } else if (config.data && typeof config.data === "string") {
        // config.data是否是string类型，string类型说明接口已经发过一次，token过期了，当无感刷新token后，再次发请求要更新Ftoken，
        // 第一次发请求config.data是jsson格式，第二次发请求config.data是string类型，要转换
        config.data = JSON.parse(config.data)
        config.data.token = store.getters.token;
      } else {
        // 否则 所有第一次 post 请求，都要传token和orgCodePt
        config.data.token = store.getters.token;
      }
    } else if (store.getters.token && config["method"] == 'get') {     // 当存在token   并且是get方法
       // config.url += "&token=" + store.getters.token;
      // 当无感刷新token后，再次发请求要更新Ftoken
      config.url = replaceGetParameter(config.url, 'token', store.getters.token)
    }

    return config;
  },
  error => {
    // console.log("request error:" + error);
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  async res => {
    // console.log("res", res)
    // return axios(res.config)
    // console.log("resres:",res)
    // 未设置状态码则默认成功状态
    const code = res.data.code || "00"
    if (code !== "00") {
      if (code === "X1") {   // X1是需要重新登陆的返回码
        Notification.error({
          title: '错误',
          message: res.data.message,
          duration: 10 * 1000
        })
        store.dispatch('user/logOut').then(() => {
          // location.reload()
        })
        return Promise.reject('error')
      }

      if (code === "X9") {         // token 过期  需要重新刷新
        Notification.error({
          title: '错误',
          message: res.data.message,
          duration: 10 * 1000
        })
        // store.dispatch('user/refreToken').then(() => {
        //   // service.request(res.config)
        // })
        return Promise.reject('error')
      }

      Notification.error({
        title: '错误',
        message: res.data.message,
        duration: 10 * 1000
      })
      return Promise.reject('error')
    } else {
      const data = res.data.data
      // console.log('data' + JSON.stringify(data))
      if (data.respCode !== "00") {
        if (data.respCode === "X5") {   // 账号被禁用;
          Notification.error({
            title: '错误',
            message: data.respDesc,
            duration: 10 * 1000
          })
          return res.data.data
        } else if (data.respCode === "X8" || data.respCode === "X1") {   //X1   刷新token也过期
          MessageBox.confirm(data.respDesc, {
            confirmButtonText: '重新登录',
            type: 'warning',
            closeOnClickModal: false,
            showCancelButton: false,
            showClose: false,
          }).then(() => {
            store.dispatch('user/logOut').then(() => {
            })
          }).catch(() => {
          });

          return Promise.reject('error')
          // token 过期  需要重新刷新
        } else if (data.respCode === "X9") {

          // 判断当前是否为刷新状态中（防止多个请求导致多次调refresh接口）
          if (!isRefreshing) {
            //设置当前状态为刷新中 正在刷新，执行else里面的逻辑
            isRefreshing = true
            await store.dispatch('user/refreToken').then((response) => {
              // 遍历队列，重新发起请求
              listRequests.forEach(item => item(response.token)) // 用新token把阻塞的接口全部重新请求
              // 重试完后，清空这个队列
              listRequests = []
            }).catch(err => {
              return Promise.reject('error');
              // location.reload()
            }).finally(() => {
              // 无论成功还是失败，都将isRefreshing设置为false
              isRefreshing = false
            })
            //return await得地方，把未完成得请求 重新再发
            return service(res.config)
          }else{
            // 返回未执行 resolve 的 Promise
            return new Promise(resolve => {
              // 用函数形式将 resolve 存入，等待刷新后再执行
              listRequests.push(token => {
                resolve(service(res.config))
              })
            })
          }


          // return Promise.reject('error')
        } else if (data.respCode === "X10") {
          // 如果token和refreshToken 不存在，提示用户 '当前会话已过期,请重新登录'
          MessageBox.confirm('当前身份不存在，请重新登录', {
            confirmButtonText: '重新登录',
            type: 'warning',
            closeOnClickModal: false,
            showCancelButton: false,
            showClose: false,
          }).then(() => {
            store.dispatch('user/logOut').then(() => {
            })
          }).catch(() => {
          });
          return Promise.reject('error')
        } else {

          Notification.error({
            title: '错误',
            message: data.respDesc,
            duration: 10 * 1000
          })
        }
        return Promise.reject('error')
      } else {
        return res.data.data
      }
    }

  },
  error => {
    let {message} = error
    if (message == 'Network Error') {
      message = '后端接口连接异常'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常'
    }

    Notification.error({
      title: '错误',
      message: message,
      duration: 5 * 1000
    });

    return Promise.reject(error)
  }
);

export default service;


function replaceGetParameter(url, parameter, value) {
  // 获取当前URL的查询字符串
  let regExp = new RegExp('([?&])' + parameter + '=.*?(&|$)', 'i');
  let separator = url.indexOf('?') !== -1 ? '&' : '?';
  // 如果参数已存在，则替换其值，否则添加新参数
  if (regExp.test(url)) {
    return url.replace(regExp, '$1' + parameter + '=' + value + '$2');
  } else {
    return url + separator + parameter + '=' + value;
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js